module.exports = __webpack_public_path__ + "static/mongo-c5e33a8673ab07cdd84ac56555e0456c.png";